import React, { useContext } from 'react';
import DomainData from '../../assets/datasets/DomainData';
import PrimaryButton from '../buttons/PrimaryButton';
import AutoSuggestField from '../forms/AutoSuggestField';
import SelectField from '../forms/SelectField';
import InputField from '../forms/InputField';
import TextArea from '../forms/TextArea';
import RatingTopFlopButton from '../forms/RatingTopFlopButton';
import ClinicRatingIcon from '../../assets/img/clinic_rating.png';
import LongLogo from '../../assets/img/logo_lang.png';
import { createDepartmentRating } from '../../api/methods';
import errorHandlers from '../../api/errorHandlers';
import { AuthContext } from '../context/Auth';
import { WindowManagerContext } from '../context/WindowManager';
import config from '../../configuration';
import axios from 'axios';
import WindowWrapper from '../context/WindowWrapper';
import CheckField from '../forms/CheckField';
import { TrackingContext } from '../context/Tracking';

const InsideTopFlop = props => {
  return (
    <>
      <b>{props.headline}</b>
      <p style={{ fontSize: 10 }}>
        {props.questions.map((q, i) => i === (props.questions.length - 1) ? <>{q}</> : <>{q}<br /></>)}
      </p>
      {
        Array.from(Array(props.comments.length)).map((_, i) => {
          return (
            <TextArea
              value={props.comments[i]}
              key={'input-' + i}
              label={props.label}
              placeholder='Stichworte :)'
              setValue={newValue => {
                const newComments = [...props.comments];
                newComments[i] = newValue;
                props.setComments(newComments);
              }}
            />
          );
        })
      }
    </>
  );
};

const texts = {
  team: {
    headline: 'Kannst du uns ein paar Stichworte dazu sagen?',
    questions: ['Wie war das Team-Klima?', ' Wie waren die Assistent:innen untereinander?', 'Wie war der Umgang mit der Pflege?'],
    label: 'Team-Klima'
  },
  einarbeitung: {
    headline: 'Kannst du uns ein paar Stichworte dazu sagen?',
    questions: ['War die Einarbeitung lang genug?', ' Wurde sich an einen strukturierten Plan gehalten?', 'Nach wie viel Wochen war der erste Dienst ?'],
    label: 'Einarbeitung'
  },
  arbeitszeiten: {
    headline: 'Kannst du uns ein paar Stichworte dazu sagen?',
    questions: ['Wie war die Arbeitslast?', ' Wie hoch war die Überstundenbelastung?', 'Wurden die Überstunden ausnahmslos bezahlt?', 'Welche Art von Zeiterfassung gab es?', 'Wie gut kann man dort Teilzeit machen?'],
    label: 'Arbeitszeit & Gehalt'
  },
  weiterbildung: {
    headline: 'Kannst du uns ein paar Stichworte dazu sagen?',
    questions: ['Gab es gute interne Fortbildungen?', ' Gab es einen strukturierten Rotationsplan?', 'Wie gut ist die Weiterbildung betreut worden?'],
    label: 'Weiterbildung'
  }/* ,
  sonstiges: {
    headline: 'Kannst du uns ein paar Stichworte dazu sagen?',
    questions: ['Was war für dich noch besonders negativ oder besonders positiv?'],
    label: 'Team-Klima'
  } */
};

const currentYear = new Date().getFullYear();

const validateSignup = (data) => {
  if (
    !(
      data.firstName &&
      data.lastName &&
      data.email &&
      data.password &&
      data.dataPrivacy &&
      data.passwordRepeat &&
      data.password === data.passwordRepeat
    )
  ) {
    alert('Bitte gib deine persönlichen Daten inklusive E-Mail-Adresse und Password an. So können wir dich verifizieren und du kannst in Zukunft auf alle Bewertungen zugreifen.');
    return false;
  }
  return true;
};

const criteria = [
  { label: 'Team-Klima', value: 'team', component: props => <InsideTopFlop {...texts.team} {...props} /> },
  { label: 'Einarbeitung', value: 'einarbeitung', component: props => <InsideTopFlop {...texts.einarbeitung} {...props} /> },
  { label: 'Arbeitszeit & Gehalt', value: 'arbeitszeiten', component: props => <InsideTopFlop {...texts.arbeitszeiten} {...props} /> },
  { label: 'Weiterbildung', value: 'weiterbildung', component: props => <InsideTopFlop {...texts.weiterbildung} {...props} /> }
  /* { label: 'Sonstiges', value: 'sonstiges', component: props => <InsideTopFlop {...texts.sonstiges} {...props} /> } */
];

const IntroText = ({ reason }) => {
  return (
    <>
      <center><img src={ClinicRatingIcon} height={100} style={{ marginTop: 50 }} /></center>
      <br />
      <p style={{ textAlign: 'center', background: 'black', color: 'white', padding: '8px 16px', borderRadius: 6, margin: '20px auto', maxWidth: 100 }}>
        ANONYM
      </p>
      {
      reason === 'unlock'
        ? (
          <>
            <h1 style={{ lineHeight: 1.2, fontWeight: 'bold', fontSize: 26, textAlign: 'center', marginLeft: 15, marginRight: 15 }}>
              Für die Freischaltung bitten wir dich, selbst eine Abteilung zu bewerten.
            </h1>
            <p style={{ textAlign: 'center', marginLeft: 15, marginRight: 15, color: 'grey' }}>
              Auch Erfahrungen aus Famulatur und PJ sind wichtig!
            </p>
            <p style={{ textAlign: 'center' }}>
              Transparenz über die Arbeitsbedingungen in den Kliniken erreichen wir nur gemeinsam. Nimm dir bitte 2 Minuten, bewerte eine Klinik, die du kennst und profitiere von den Erfahrungen aller anderen. So können wir gemeinsam etwas verändern und einander helfen.&nbsp;<br />
              <b>Natürlich vollkommen anonym!</b>
            </p>
            <br />
            <br />
          </>
          )
        : (
          <>
            <h1 style={{ lineHeight: 1.2, fontWeight: 'bold', fontSize: 26, textAlign: 'center', marginLeft: 15, marginRight: 15 }}>
              Deine Bewertung für alle Medis!
            </h1>
            <p style={{ textAlign: 'center' }}>
              Um auf alle anderen Bewertungen zugreifen zu können, kannst du hier eine eigene Bewertung abgeben. Trage dazu bei, die Arbeitsbedingungen transparenter zu machen und langfristig zu verbessern.
              Deine Angaben sind natürlich <b>vollkommen anonym</b>.
            </p>
            <br />
            <br />
          </>
          )
    }
    </>
  );
};

const CreateRating = ({ style, close, className, ...props }) => {
  const border = '0.5px solid rgba(115, 115, 115, 0.4)';
  const borderRadius = 6;
  const height = 42;
  const fontSize = 13;

  // Clinic an department information
  const [clinic, setClinic] = React.useState({});
  const [department, setDepartment] = React.useState(props.department || {});
  const [clinicValue, setClinicValue] = React.useState(props.clinic?.name || '');

  // rating info
  const [recommendation, setRecommendation] = React.useState({ recommended: null, comments: [] });
  const [ratingPerspective, setRatingPerspective] = React.useState(null);
  const [ratingTime, setRatingTime] = React.useState(null);
  const [wantsSignup, setWantsSignup] = React.useState(false);
  const [ratings, setRatings] = React.useState(
    props.ratings || criteria.map(c => c.value).reduce((o, key) => Object.assign(o, { [key]: { rating: null, comments: [''] } }), {})
  );

  // loading status
  const [sendLoading, setSendLoading] = React.useState(false);
  const [ratingDone, setRatingDone] = React.useState(false);

  // clinic and department data
  const [allClinics, setAllClinics] = React.useState([]);
  const [departmentsForClinic, setDepartmentForClinics] = React.useState([]);

  // context and scroll
  const { auth, user, login, signup, setLoggedIn } = useContext(AuthContext);
  const { openWindow, closeWindow } = useContext(WindowManagerContext);
  const [formKey, setFormKey] = React.useState(1);
  const scroller = React.useRef(null);
  const { t, source } = useContext(TrackingContext);

  // sign up
  const [data, setData] = React.useState({});

  const editData = (key, value) => {
    if (!Object.keys({ ...data }).includes(key)) t('action', 'create_rating_input', key);
    setData(old => ({ ...old, [key]: value }));
  };

  const createRating = async () => {
    openWindow('loading', {});
    setSendLoading(true);
    const rating = {
      clinic_id: clinic.id,
      type: 'department',
      entity_id: department.id,
      recommended: recommendation.recommended,
      perspective: ratingPerspective,
      experience_time: ratingTime,
      recommended_for: recommendation.comments,
      owner: (auth.loggedIn ? user?.email : data.email) || null,
      source,
      ratings
    };
    try {
      const ratingInfo = await createDepartmentRating(rating);
      t('action', 'created_rating', '' + ratingInfo.id);
      setSendLoading(false);
      if (auth.loggedIn) {
        setRatingDone(true);
        setFormKey(old => old + 1);
        closeWindow('loading');
      } else {
        if (!wantsSignup) {
          setRatingDone(true);
          setFormKey(old => old + 1);
          setLoggedIn();
          closeWindow('loading');
          return;
        }
        const { firstName, lastName, email, password, passwordRepeat } = data;
        const signupData = {
          firstName, lastName, email, password, passwordRepeat, ratingId: ratingInfo.map(r => r.id)
        };
        try {
          if (!validateSignup(data)) return;
          await signup(signupData);
          t('action', 'created_rating_signup');
          closeWindow('loading');
          close();
          openWindow('notification', {
            content: (
              <>
                <center><img src={LongLogo} height={70} /></center>
                <div style={{ maxWidth: 400, margin: '20px auto' }}>
                  <center>
                    <p style={{ fontWeight: 'bold', fontSize: 24 }}>Herzlich Willkommen bei Felix Medicus!</p>
                    <p>Du kannst nun auf alle Bewertungen zugreifen.</p>
                    <PrimaryButton onClick={() => { closeWindow('notification'); close(); }}>Jetzt loslegen</PrimaryButton>
                  </center>
                </div>
              </>
            )
          });
          login(data.email, data.password);
          t('action', 'created_rating_login');
        } catch (e) {
          t('action', 'created_rating_login_error', e.message);
          errorHandlers.signupErrorHandler(e.response.data);
          throw Error('');
        }
        // openWindow('signup', { madeRating: true, rating: ratingInfo });
      }
    } catch (error) {
      console.log(error);
      if (error.message) alert('Ein Fehler ist aufgetreten: ' + error.message);
      t('error', 'created_rating_error', '' + error.message);
      setSendLoading(false);
      closeWindow('loading');
    }
  };

  React.useEffect(() => {
    if (scroller.current) scroller.current.scrollIntoView();
  }, [formKey]);

  React.useEffect(() => {
    axios.get(config.backendAddress + '/open/getAllClinicNames')
      .then(result => setAllClinics(result.data))
      .catch(error => console.log(error));
  }, []);

  React.useEffect(() => {
    if (clinicValue && allClinics?.length > 0) {
      const clinicObject = allClinics.find(c => c.name === clinicValue) || null;
      console.log(clinicValue, clinicObject);
      // console.log((clinicObject.name !== clinic?.name || departmentsForClinic.length === 0));
      if (clinicObject && (clinicObject.name !== clinic?.name || departmentsForClinic.length === 0)) {
        axios.get(config.backendAddress + '/open/getDepartmentNamesByClinicId?clinicId=' + clinicObject.id)
          .then(result => setDepartmentForClinics(old => result.data))
          .catch(error => console.log(error));
      }
      setClinic(clinicObject);
    }
  }, [clinicValue, clinic, allClinics]);

  return (
    <>
      <WindowWrapper
        key={formKey}
        maxWidth={600}
        maxHeight={600}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={style}
        close={close}
      >
        <div ref={scroller} />
        <div>
          <center><img src={LongLogo} height={60} /></center>
        </div>
        {
          ratingDone
            ? (
              <>
                <center><img src={ClinicRatingIcon} height={100} style={{ marginTop: 50 }} /></center>
                <br />
                <br />
                <h1 style={{ lineHeight: 1.2, fontWeight: 'bold', fontSize: 26, textAlign: 'center', marginLeft: 15, marginRight: 15 }}>
                  Vielen Dank für deine Bewertung!
                </h1>
                <p style={{ textAlign: 'center' }}>
                  JEDE einzelne Bewertung hilft allen Mediziner:innen. Du hilfst also allen anderen und am Ende auch dir - weil du unseren Service relevanter gemacht hast :)
                </p>
                <br />
                <center><PrimaryButton scale={1.2} onClick={() => { setRatingDone(false); setFormKey(old => old + 1); }}>Neue Bewertung abgeben</PrimaryButton></center>
              </>
              )
            : (
              <React.Fragment key={'form-' + formKey}>
                <IntroText reason={props.reason} />
                <b>Welche Abteilung möchtest du bewerten?</b>
                <AutoSuggestField
                  setValue={setClinicValue}
                  value={clinicValue}
                  label='Klinik-Name'
                  placeholder={allClinics.length === 0 ? 'Lädt Klinik-Daten' : 'Klinik-Name'}
                  suggestions={allClinics.map(c => ({ value: c.name, label: c.name })) || []}
                />
                <SelectField
                  setValue={(subjectArea) => setDepartment(old => ({ id: departmentsForClinic.find(d => d.subject_area === subjectArea)?.id || old.id || '', subject_area: subjectArea }))}
                  value={department.subject_area}
                  label='Abteilung'
                  placeholder={departmentsForClinic.length === 0 ? 'Wartet auf Abteilungen für Klinik...' : 'Abteilungs-Name'}
                  options={departmentsForClinic.map(d => ({ value: d.subject_area, label: d.subject_area })) || []}
                  /* style={{
                    height,
                    border,
                    borderRadius,
                    fontSize
                  }} */
                />
                <br />
                <hr style={{ width: '120%', marginLeft: -20 }} />
                <br />
                <i>Bitte achte darauf, dass du eine angemessene Sprache verwendest und niemanden persönlich beleidigst.</i>
                <br />
                <b>Woher kennst du die Abteilung?</b>
                <SelectField
                  options={[
                    { value: 'Famulatur', label: 'Famulatur' },
                    { value: 'PJ', label: 'PJ' },
                    { value: 'Assistenzarztzeit', label: 'Assistenzarztzeit' }
                  ]}
                  value={ratingPerspective}
                  setValue={setRatingPerspective}
                  /* style={{
                    height,
                    border,
                    borderRadius,
                    fontSize
                  }} */
                />
                <br />
                <b>Wann hast du dort gearbeitet?</b>
                <SelectField
                  options={[
                    { value: currentYear, label: 'Ich arbeite jetzt gerade dort' },
                    ...Array.from(Array(10)).map((_, i) => ({ value: (currentYear - i), label: (currentYear - i) }))
                  ]}
                  value={ratingTime}
                  setValue={setRatingTime}
                  /* style={{
                    height,
                    border,
                    borderRadius,
                    fontSize
                  }} */
                />
                <br />
                <br />
                <hr style={{ width: '120%', marginLeft: -20 }} />
                <br />
                <b>
                  {
              (ratingPerspective === 'PJ' || ratingPerspective === 'Famulatur')
                ? 'Wie hast du die Arbeitsbedingungen für die Assistent:innen wahrgenommen?'
                : 'Wie würdest du die Arbeitsbedingungen für Assistent:innen bewerten?'
            }
                </b>
                <br />
                <i>Du kannst mehrere auswählen.</i>
                <br /><br />
                {
                  criteria.map(({ label, value: index, component: CriteriaComponent }) => {
                    return (
                      <RatingTopFlopButton
                        label={label}
                        value={ratings[index].rating}
                        setValue={newRating => setRatings(old => ({ ...old, [index]: { ...ratings[index], rating: newRating } }))}
                        key={'topflop-' + index}
                      >
                        <CriteriaComponent comments={ratings[index].comments} setComments={newComments => setRatings(old => ({ ...old, [index]: { ...ratings[index], comments: newComments } }))} />
                      </RatingTopFlopButton>
                    );
                  })
                }
                <br />
                <hr style={{ width: '120%', marginLeft: -20 }} />
                <br />
                <br />
                <b>Kannst du diese Abteilung empfehlen?</b>
                <RatingTopFlopButton
                  label='Empfehlung?'
                  value={recommendation.recommended}
                  setValue={newRating => setRecommendation(old => ({ ...recommendation, recommended: newRating }))}
                >
                  {
                    recommendation.recommended
                      ? (
                        <>
                          <b>Wem kannst du diese Abteilung empfehlen?</b>
                          <br />
                          <i>Du kannst mehrere auswählen.</i>
                          <br />
                          <SelectField
                            options={[
                              { value: '_all', label: 'Jedem' },
                              { value: 'PJ', label: 'PJler:innen' },
                              { value: 'Berufsstart', label: 'Berufsstarter:innen' },
                              { value: 'Erfahreneren', label: 'Fortgeschrittene Assistent:innen' }
                            ]}
                            multi
                            value={recommendation.comments}
                            setValue={newComments => { console.log(newComments); setRecommendation(old => ({ ...recommendation, comments: newComments })); }}
                            style={{
                              height,
                              border,
                              borderRadius,
                              fontSize
                            }}
                          />
                        </>
                        )
                      : null
                  }
                </RatingTopFlopButton>
                {
                !auth.loggedIn && (
                  <>
                    <br />
                    <br />
                    {
                      !wantsSignup && (
                        <>
                          <br />
                          <b>Deine E-Mail-Adresse (wird nicht veröffentlicht)</b><br />
                          <p><i>Diese brauchen wir für die <span style={{ color: 'green' }}><i className='fa fa-check' /> Verifizierung</span>. <b>Die Bewertung bleibt natürlich jederzeit anonym!</b></i><br /></p>
                          <InputField value={data.email || ''} setValue={value => editData('email', value)} type='email' label='E-Mail-Adresse' placeholder='E-Mail-Adresse' />
                          <br />
                          <br />
                        </>
                      )
                    }
                    <b style={{ fontSize: 20, lineHeight: 1.1 }}>Zugriff auf alle zukünftigen Bewertungen</b>
                    <br />
                    <br />
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <CheckField
                              setValue={(value) => { t('action', value ? 'create_rating_activate_signup' : 'create_rating_deactivate_signup'); setWantsSignup(value); }}
                              value={wantsSignup}
                              classic
                            />
                          </td>
                          <td style={{ paddingLeft: 15 }}>
                            <p style={{ marginBottom: 5, fontSize: 'smaller' }}>
                              Ich möchte zukünftig weiterhin Zugriff auf die Bewertungen haben
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    {
                    wantsSignup && (
                      <>
                        <p style={{ color: 'grey' }}>
                          <i>Damit du weiterhin Zugriff auf alle Bewertungen hast, musst du einen Account erstellen. Mit dem Account kannst du dann immer wieder auf Felix Medicus Bewertungen sehen.
                          &nbsp;Zusätzlich können wir so deine Bewertung <nobr><span style={{ color: 'green' }}><i className='fa fa-check' /> verifizieren</span></nobr>. <b>Die Bewertung bleibt natürlich jederzeit anonym!</b>
                          </i>
                        </p>
                        <b>Dein Vorname (wird nicht veröffentlicht)</b>
                        <InputField value={data.firstName || ''} setValue={value => editData('firstName', value)} label='Vorname' placeholder='Vorname' />
                        <b>Dein Nachname (wird nicht veröffentlicht)</b>
                        <InputField value={data.lastName || ''} setValue={value => editData('lastName', value)} label='Nachname' placeholder='Nachname' />

                        <b>Deine E-Mail-Adresse (wird nicht veröffentlicht)</b>
                        <InputField value={data.email || ''} setValue={value => editData('email', value)} type='email' label='E-Mail-Adresse' placeholder='E-Mail-Adresse' />

                        <b>Dein Passwort</b>
                        <InputField type='password' value={data.password || ''} setValue={value => editData('password', value)} label='Passwort' placeholder='Passwort' />

                        <b>Passwort wiederholen</b>
                        <InputField type='password' value={data.passwordRepeat || ''} setValue={value => editData('passwordRepeat', value)} label='Passwort wiederholen' placeholder='Passwort wiederholen' />
                        <br />
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <CheckField
                                setValue={(value) => editData('dataPrivacy', value)}
                                value={data.dataPrivacy}
                                classic
                              />
                              </td>
                              <td>
                                <p style={{ color: 'grey', fontSize: 'smaller', marginBottom: 5, paddingLeft: 15 }}>
                                Ich bin mit der <a style={{ color: 'black', textDecoration: 'underline' }} href={config.website + config.websiteRoutes.dataPrivacy} rel='noopener noreferrer' target='_blank'>Datenschutzerklärung</a> & <a style={{ color: 'black', textDecoration: 'underline' }} href={config.website + config.websiteRoutes.agb} rel='noopener noreferrer' target='_blank'>AGBs</a> einverstanden
                              </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )
}
                  </>
                )
              }
                <br />
                <center><PrimaryButton onClick={() => createRating()} scale={1.3}>{sendLoading ? 'Lädt...' : 'Absenden'}</PrimaryButton></center>
              </React.Fragment>
              )
        }
      </WindowWrapper>
    </>
  );
};

export default CreateRating;
